import { render, staticRenderFns } from "./DosForm.vue?vue&type=template&id=05f4743f&"
import script from "./DosForm.vue?vue&type=script&lang=js&"
export * from "./DosForm.vue?vue&type=script&lang=js&"
import style0 from "./DosForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports